import React, { useEffect, useState } from "react";
import { ApiCall, Colors } from "../../common/Const";
import Footer from "../pages/Footer";
import Header from "../pages/Header";
import Profileleft from "./Profileleft";
import "../Myprofiecomponent/Myaddress.css";
import { Radio } from "@mui/material";
import { Link } from "react-router-dom";
import { data } from "jquery";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EncryptDecrypt from "../../common/Crypto";
import { useSelector } from "react-redux";
import { images } from "../../common/Images";
import { MutatingDots } from "react-loader-spinner";
const Address = () => {
    const user = useSelector((state) => state.auth.user);

  const [cusId, setcusId] = useState(user && user.id > 0 ? user.id : 0);
  const [cusaddresses, setAddresses] = useState([]);
  const [addressid, setAddressid] = useState(0);
  const [checkedAdress, setCheckedaddress] = useState(1);
  const [render, setrender] = useState(true);

  {
    /**for decrypt the encrypted customer id */
  }
  // const DecryptData = async () => {
  //   let type = "decrypt";
  //   let format = "text";
  //   let id = localStorage.getItem("customerId");
  //   await EncryptDecrypt(id, type, format, (response) => {
  //     console.log("decode -->", response);
  //     setcusId(response);
  //   });
  // };

  // useEffect(() => {
  //   DecryptData();
  // }, []);

  {
    /**for mui radio butto */
  }
  const controlProps = (item) => ({
    checked: checkedAdress === item,
    onChange: handleChange,
    value: item,
    name: "color-radio-button-demo",
    inputProps: { "aria-label": item },
  });

  const handleChange = (event) => {
    setCheckedaddress(event.target.value);
  };

  {
    /**address view api */
  }
  const handleAddress = () => {
    const cust_id = { customer_id: cusId };
    ApiCall("viewAddress", cust_id)
      .then((data) => {
        setAddresses(data.result);
      })
      .catch((err) => console.log(err));
  };

  {
    /**address delete api */
  }
  const handlesetDelete = (e) => {
    const removeId = { address_id: e.target.id };
    ApiCall("removeAddress", removeId)
      .then((data) => {
        if (data.message == "Success") {
          setrender(!render);
          toast.success("Address deleted successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error("Can't Delete default Address", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      })
      .catch((err) => console.log(err));
  };

  {
    /**change default address api */
  }
  const changeDefalutaddress = (e) => {
    const defaultParams = { address_id: e.target.id, customer_id: cusId };
    console.log(defaultParams);
    ApiCall("defaultAddress", defaultParams)
      .then((data) => {
        if (data.message == "Success") {
          setrender(!render);
          toast.success("Default address update successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error("Failure", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      })
      .catch((err) => console.log(err));
  };

  // useEffect(() => {
  //   handleAddress();
  // }, [cusId]);

  useEffect(() => {
    handleAddress();
    console.log(render);
  }, [render, cusId]);

  // console.log(cusaddresses);
  return (
    <>
      <Header make={true} />
      <div className="profile-myaddress ">
        <div
          className="myprofilebox pb-5 "
          style={{ backgroundColor: "#fef4f7", height: "100%" }}
        >
          <div style={{width:"250px"}}>
              <div className="row" style={{marginBottom:"20px"}}>
                <div className="col-5">
                  <a href="javascript:history.go(-1)"><button className="btn btn-basic p-0" style={{background: Colors.Base_color,color:"white"}} ><img src={images.left} width={30}/><span style={{position: "relative",left: "-8px",top: "2px"}}>Back</span></button></a>
                </div>
                <div className="col-7" style={{paddingTop: "7px"}}>
                  <h4>User Profile</h4>
                </div>
              </div>
            </div>
          <div
            className="profilecontainer row mx-0 gap-4"
            style={{ paddingTop: "20px", height: "100%", paddingBottom: '20px' }}
          >
            <Profileleft />
            <div
              className="right col-11 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8"
              style={{
                backgroundColor: Colors.white_color,
                height: "max-content",
                borderRadius: "20px",
                marginBottom: "40px",
              }}
            >
              <div className=" address-field mt-5">
                {cusaddresses && cusaddresses.length > 0 &&<div className="save-new-btn">
                  <span className="heading-saved-address">Saved Address</span>
                  <Link
                    to="/new-address"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    <button type="button" className="btn addaddressbtn">
                      Add New Address
                    </button>
                  </Link>
                </div> }

                <div className="container mt-5 mb-5">
                  {/* {cusaddresses == undefined ? (
                    <div className="emptypage">
                      <span>No Address</span>
                      <Link
                        to="/new-address"
                        style={{ color: "white", textDecoration: "none" }}
                      >
                        <button type="button" className="btn addaddressbtn">
                          Add New Address
                        </button>
                      </Link>
                    </div>
                  ) : ( */}
                  {cusaddresses.length == 0 ? (
                    <div
                    className="d-flex align-items-center justify-content-center w-100"
                    style={{ height: "100vh" }}
                  >
                    <MutatingDots
                      height="100"
                      width="100"
                      color={Colors.Base_color}
                      secondaryColor={Colors.Base_color}
                      radius="12.5"
                      ariaLabel="mutating-dots-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={true}
                    /> 
                  </div>
                     ) : 
                     <div className="row default-address mt-2 align-items-center">
                      <div className="col-xxl-8 col-xl-8 col-md-12 col-12">
                        <div className="">
                          {cusaddresses.map((listaddress, i) => {
                            console.log(listaddress);
                            return (
                              <>
                                <ul className="adresslist">
                                  <li className="">
                                    <div className="d-flex flex-column w-100">
                                      <div className="row address-details align-items-center" style={{width:"100%"}}>
                                        <div className=" col-4">
                                          <Radio
                                            {...controlProps(
                                              listaddress.default_address
                                            )}
                                            sx={{
                                              color: "#126a38",
                                              "&.Mui-checked": {
                                                color: "#126a38",
                                              },
                                            }}
                                            
                                            id={listaddress.id}
                                            onChange={(e) =>
                                              changeDefalutaddress(e)
                                            }
                                          />
                                          <label className="a-title text-capitalize">
                                            {listaddress.specification}
                                          </label>
                                        </div>
                                        <div className="  col-4 " style={{position:"relative",left:"-10px"}}>
                                          <button
                                            type="button"
                                            className="btn btn-sm default "
                                            id={listaddress.id}
                                            onClick={(e) =>
                                              changeDefalutaddress(e)
                                            }
                                            style={{width: "110px"}}
                                          >
                                            {listaddress.default_address == 1
                                              ? "Default"
                                              : "Set As Default"}
                                          </button>
                                        </div>
                                        <div className="col-3" style={{position:"relative",left:"10px"}}>
                                          <i
                                            class="fa-solid fa-trash"
                                            style={{
                                              cursor: "pointer",
                                              color: "#126a38",
                                            }}
                                            data-bs-toggle="modal"
                                            data-bs-target="#staticBackdrop"
                                            id={listaddress.id}
                                            onClick={(e) =>
                                              setAddressid(e.target.id)
                                            }
                                          ></i>
                                        </div>
                                      </div>
                                      <div className="ps-5 pt-3 ">
                                        <span className="address pt-3">
                                          {listaddress.address_1},
                                          {listaddress.city},{listaddress.state}
                                          , {listaddress.post_code}, India{" "}
                                        </span>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </>
                            );
                          })}
                        </div>
                      </div>
                      <div className="col-xxl-3 col-xl-3 col-md-12 col-12 ">
                        {/* <Link
                          to="/new-address"
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          <button type="button" className="btn addaddressbtn">
                            Add New Address
                          </button>
                        </Link> */}
                      </div>
                      {/**delete modal */}
                      <div
                        class="modal fade"
                        id="staticBackdrop"
                        data-bs-backdrop="static"
                        data-bs-keyboard="false"
                        tabindex="-1"
                        aria-labelledby="staticBackdropLabel"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog modal-dialog-centered">
                          <div class="modal-content">
                            <div class="modal-header">
                              <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div
                              class="modal-body mdl-body"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              Are you sure want to delete?
                            </div>
                            <div
                              class="modal-footer gap-3"
                              style={{ justifyContent: "center" }}
                            >
                              <button
                                type="button"
                                className="btn"
                                style={{
                                  backgroundColor: "#126a38",
                                  color: "white",
                                  fontFamily: "AvenirLTStdLight",
                                }}
                                data-bs-dismiss="modal"
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="btn px-4"
                                style={{
                                  backgroundColor: "#126a38",
                                  color: "white",
                                  fontFamily: "AvenirLTStdLight",
                                }}
                                data-bs-dismiss="modal"
                                id={addressid}
                                onClick={(e) => handlesetDelete(e)}
                              >
                                yes
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                      }
                  {/* )} */}
                </div>
              </div>
            </div> 
            
          </div>
        </div>
        <ToastContainer />
      </div>
      <Footer />
    </>
  );
};

export default Address;
